import React from "react";
import "./Legal.css";
import V2LegalLayout from "../../v2/V2Legal";

/* Shared shell + building blocks for /privacy and /terms (Apple design language). */

export function Section({ id, title, children }) {
  return (
    <section id={id} className="lg-section" aria-labelledby={`${id}-h`}>
      <h2 id={`${id}-h`}>{title}</h2>
      <div className="lg-section-body">{children}</div>
    </section>
  );
}

export function P({ children }) {
  return <p className="lg-p">{children}</p>;
}

export function UL({ items }) {
  return (
    <ul className="lg-ul">
      {items.map((item, i) => <li key={i}>{item}</li>)}
    </ul>
  );
}

export function Callout({ type = "info", children }) {
  return (
    <div className={`lg-callout lg-callout--${type}`} role="note">
      <svg className="lg-callout-icon" width="18" height="18" viewBox="0 0 20 20" fill="none" aria-hidden="true">
        {type === "warning"
          ? <><path d="M10 2.5 18.5 17h-17z" fill="currentColor" opacity=".18" /><path d="M10 2.5 18.5 17h-17z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" /><path d="M10 8v4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" /><circle cx="10" cy="14.6" r="1" fill="currentColor" /></>
          : <><circle cx="10" cy="10" r="8" fill="currentColor" opacity=".18" /><circle cx="10" cy="10" r="8" stroke="currentColor" strokeWidth="1.5" /><path d="M10 9v5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" /><circle cx="10" cy="6.2" r="1" fill="currentColor" /></>}
      </svg>
      <div>{children}</div>
    </div>
  );
}

export function ContactCard({ rows }) {
  return (
    <dl className="lg-contact">
      {rows.map(({ label, value }) => (
        <div className="lg-contact-row" key={label}>
          <dt>{label}</dt>
          <dd>{value}</dd>
        </div>
      ))}
    </dl>
  );
}

// Privacy / Terms render in the v2 legal layout (src/v2/V2Legal.js); the building blocks above
// produce the .lg-* markup it styles.
export default function LegalLayout(props) {
  return <V2LegalLayout {...props} />;
}
